export default "__VITE_ASSET__a9423566__"